import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/noData_empty.svg'


const _hoisted_1 = { class: "h-screen flex flex-col font-montserrat relative" }
const _hoisted_2 = { class: "flex flex-col bg-white" }
const _hoisted_3 = { class: "w-full h-full bg-white justify-center items-center flex flex-col mx-auto my-20 text-12px xxl:text-14px overflow-hidden" }
const _hoisted_4 = { class: "absolute w-full bottom-0 mb-12" }
const _hoisted_5 = { class: "w-full h-full bg-white justify-center items-center flex flex-col mx-auto text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-32 mt-8 mx-auto",
  alt: "empty"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2" }, " Belum ada data vendor yang dapat ditampilkan ", -1)
const _hoisted_8 = { class: "border-t border-gray-lp-200 border-b overflow-y-auto h-screen pb-24" }
const _hoisted_9 = { class: "absolute w-full bottom-0 mb-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_TableLazyLoad = _resolveComponent("TableLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_TableV1 = _resolveComponent("TableV1")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Header, {
        isSearchable: true,
        placeholder: "Cari nama atau kode vendor",
        currentRoutes: _ctx.getCurrentRoute,
        isSelectStatus: true,
        clearSearch: _ctx.clearSearch,
        searchValue: _ctx.search,
        searchAction: _ctx.onSearch,
        statusData: _ctx.statusData,
        onOpenStatusSelect: _ctx.onOpenStatusSelect,
        onCloseStatusSelect: _ctx.onCloseStatusSelect,
        onSelectStatus: _ctx.onSelectStatus,
        valueStatus: _ctx.statusName,
        statusSelect: _ctx.statusSelect
      }, null, 8, ["currentRoutes", "clearSearch", "searchValue", "searchAction", "statusData", "onOpenStatusSelect", "onCloseStatusSelect", "onSelectStatus", "valueStatus", "statusSelect"])
    ]),
    _withDirectives(_createVNode(_component_TableLazyLoad, { columns: _ctx.columns }, null, 8, ["columns"]), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode(_component_ErrorMessage, { errorType: "notfound" }, null, 512), [
      [_vShow, 
        _ctx.vendors.length === 0 &&
          !_ctx.isLoading &&
          _ctx.pagination === 1 &&
          !_ctx.isFirstRequest
      ]
    ]),
    _withDirectives(_createVNode(_component_ErrorMessage, {
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getListVendor
    }, null, 8, ["errorType", "onTryAgain"]), [
      [_vShow, _ctx.isError && !_ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode(_component_ErrorMessage, { errorType: "lastPage" }),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Pagination, {
          onNext: _ctx.nextPage,
          onPrevious: _ctx.prevPage,
          page: _ctx.pagination,
          toPage: _ctx.toPage
        }, null, 8, ["onNext", "onPrevious", "page", "toPage"])
      ])
    ], 512), [
      [_vShow, 
        _ctx.vendors.length === 0 &&
          !_ctx.isLoading &&
          _ctx.pagination !== 1 &&
          !_ctx.isFirstRequest
      ]
    ]),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7
    ], 512), [
      [_vShow, 
        _ctx.vendors.length === 0 &&
          !_ctx.isLoading &&
          _ctx.pagination === 1 &&
          _ctx.searchValue === '' &&
          !_ctx.isError &&
          _ctx.isFirstRequest
      ]
    ]),
    _withDirectives(_createVNode("div", _hoisted_8, [
      _createVNode(_component_TableV1, {
        columns: _ctx.columns,
        data: _ctx.vendors,
        class: "my-8",
        onClick: _ctx.onClickRow,
        isDetailAble: _ctx.isDetailAble
      }, null, 8, ["columns", "data", "onClick", "isDetailAble"])
    ], 512), [
      [_vShow, _ctx.isShowTable]
    ]),
    _withDirectives(_createVNode("div", _hoisted_9, [
      _createVNode(_component_Pagination, {
        onNext: _ctx.nextPage,
        onPrevious: _ctx.prevPage,
        page: _ctx.pagination,
        isButtonNext: _ctx.vendors.length >= _ctx.limit,
        toPage: _ctx.toPage,
        totalData: _ctx.vendors.length
      }, null, 8, ["onNext", "onPrevious", "page", "isButtonNext", "toPage", "totalData"])
    ], 512), [
      [_vShow, _ctx.isShowTable]
    ])
  ]))
}